import { IApplicationState } from '../../types/redux';
import { getUrlPath } from '../path';

export const promosSeoPageUrlSelector = (state: IApplicationState): string => {
  const fullPath = getUrlPath(state);

  return `${fullPath}akcii-i-skidki/`;
};
